import React from 'react'
import PropTypes from 'prop-types'
import playStore from '../../../../../assets/playstore.svg'
import StoreButtonBase from './StoreButtonBase'

const PlayStore = props => (
  <StoreButtonBase
    {...props}
    src={playStore}
    alt="Play Store"
  />
)

PlayStore.defaultProps = {
  height: 30
}

PlayStore.propTypes = {
  href: PropTypes.string.isRequired,
  height: PropTypes.number
}

export default PlayStore
